// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "" + (chunkId === 245 ? "component---src-pages-index-tsx" : chunkId) + "-" + {"245":"4a5fc05bb1f8006e8122","522":"098c34049d6eda5064e4"}[chunkId] + ".js";
};